<template>
  <div>
    <Conexion v-if="accion !== 'create'"></Conexion>
    <el-alert
      v-if="accion !== 'update'"
      title="CREACIÓN DE EMPRESA"
      type="warning"
      description="Al iniciar la creación de la empresa, se generará una base de datos dedicada para su funcionamiento. Este proceso tomará un tiempo, le agradecemos su paciencia."
      show-icon
      :closable="false"
      class="mb-3"
    />

    <form
      method="POST"
      data-vv-scope="crearActualizarEmpresa"
      @submit.prevent="guardarEmpresa"
    >

    <!-- Datos generales -->
    <b-card>
        <template #header>
            <h6 class="mb-0 font-weight-bold">Datos generales</h6>
        </template>

        <b-card-body class="p-2">

            <b-row>

            <b-col sm="12" md="3">
          <b-form-group>
            <label for="nombre"> Nit <span style="color: red">(*)</span> </label>
            <b-form-input
              id="nit"
              name="nit"
              v-validate="'required|numeric|min:6|max:9'"
              data-vv-as=" "
              v-model="selectedEmpresa.nit"
              @paste="sanitizarNit"
              @keypress="sanitizarNit"
            />
            <span
              class="text-danger span-error small"
              v-text="errors.first('crearActualizarEmpresa.nit')"
            />
          </b-form-group>
        </b-col>

        <b-col sm="12" md="3">
          <b-form-group>
            <label for="nombre"> Nombre <span style="color: red">(*)</span> </label>
            <b-form-input
              id="nombre"
              name="nombre"
              data-vv-as=" "
              v-validate="'required|max:255'"
              v-model="selectedEmpresa.nombre"
              @keyup="sanitizarNombre"
            />
            <span
              class="text-danger span-error small"
              v-text="errors.first('crearActualizarEmpresa.nombre')"
            />
          </b-form-group>
        </b-col>

        <b-col sm="12" md="3">
          <b-form-group>
            <label for="direccion">Dirección <span style="color: red">(*)</span></label>
            <b-form-input
              id="direccion"
              name="direccion"
              data-vv-as=" "
              v-validate="'max:255'"
              v-model="selectedEmpresa.direccion"
            />
            <span
              class="text-danger span-error small"
              v-text="errors.first('crearActualizarEmpresa.direccion')"
            />
          </b-form-group>
        </b-col>
        <b-col sm="12" md="3">
          <b-form-group>
            <label for="telefono">Telefono <span style="color: red">(*)</span></label>
            <b-form-input
              id="telefono"
              name="telefono"
              data-vv-as=" "
              v-validate="'max:50'"
              v-model="selectedEmpresa.telefono"
            />
            <span
              class="text-danger span-error small"
              v-text="errors.first('crearActualizarEmpresa.telefono')"
            />
          </b-form-group>
        </b-col>
        <b-col sm="12" md="3">
          <b-form-group>
            <label for="responsable">
              Responsable <span style="color: red">(*)</span>
            </label>
            <b-form-input
              id="responsable"
              name="responsable"
              data-vv-as=" "
              v-validate="'required|max:100'"
              v-model="selectedEmpresa.responsable"
            />
            <span
              class="text-danger span-error small"
              v-text="errors.first('crearActualizarEmpresa.responsable')"
            />
          </b-form-group>
        </b-col>
        <b-col sm="12" md="3">
          <b-form-group>
            <label for="responsable">Correo Electrónico <span style="color: red">(*)</span></label>
            <b-form-input
              type="email"
              id="correo"
              name="correo"
              data-vv-as=" "
              v-validate="'email'"
              v-model="selectedEmpresa.correo"
            />
            <span
              class="text-danger span-error small"
              v-text="errors.first('crearActualizarEmpresa.correo')"
            />
          </b-form-group>
        </b-col>

        <b-col sm="12" md="3">
          <label for="estado">Responsable Interno</label>
          <el-select
            v-model="selectedEmpresa.responsable_interno"
            filterable
            clearable
            no-data-text="No hay datos que coincidan"
            no-match-text="No hay datos que coincidan"
          >
            <el-option
              v-for="usuario in listadoUsuarioInternos"
              :key="usuario.id"
              :label="usuario.name"
              :value="usuario.id"
            >
            </el-option>
          </el-select>
        </b-col>

        <b-col sm="12" md="3">
          <b-form-group label="Control de accesos">
            <b-form-radio-group
              id="control_accesos"
              v-model="selectedEmpresa.aplica_control_accesos"
              :options="opciones"
              buttons
              :button-variant="
                  selectedEmpresa.aplica_control_accesos
                  ? 'outline-primary'
                  : 'outline-secondary'
              "
              name="control_accesos"
            />
          </b-form-group>
        </b-col>

        <b-col sm="12" md="3">
          <b-form-group label="Agregar al nuevo modelo de negocios">
            <b-form-radio-group
              id="control_accesos"
              v-model="selectedEmpresa.is_new_business_model"
              :options="opciones"
              buttons
              :button-variant="
                  selectedEmpresa.is_new_business_model
                  ? 'outline-primary'
                  : 'outline-secondary'
              "
              name="control_accesos"
            />
          </b-form-group>
        </b-col>

        </b-row>

        </b-card-body>
    </b-card>

      <!-- Microsoft Online Azure -->
      <div class="accordion" role="tablist" v-if="this.accion !== 'create'">
        <b-card no-body class="mb-1">
          <b-button class="text-left py-2 d-flex justify-content-between align-items-center" block  variant="light" @click="toggleDropdownConfigAzure">
            <h6 class="mb-0 font-weight-bold">Microsoft Online Azure</h6>
            <div class="badge badge-light px-2 py-2">
              <span>
              {{ isOpenConfigAzure ? 'OCULTAR' : 'VER MÁS' }}
              </span>
              <i class="fa" :class="isOpenConfigAzure ? 'fa-arrow-up' : 'fa-arrow-down'"></i>
            </div>
          </b-button>
          <b-collapse accordion="my-accordion" role="tabpanel" v-model="isOpenConfigAzure">
            <b-row>

              <b-col sm="12" :md="selectedEmpresa.use_auth_microsoft_azure ? 4 : 12">

                <div class="d-flex justify-content-center align-items-center" :style="selectedEmpresa.use_auth_microsoft_azure ? 'margin-top: 120pt;' : 'margin-top: 20pt;'">

                  <!-- Logo Soluquim -->
                  <img
                    src="img/logo_soluquim.png"
                    alt="Logo Soluquim"
                    width="150"
                    height="auto"
                    class="d-block mx-2"
                  />

                </div>

                <!-- Inicio de sesión con Microsoft Online (Azure) -->
                <b-form-group label="Inicio de sesión con Microsoft Online (Azure)" class="mt-4 text-center">
                  <b-form-radio-group
                    id="use_auth_microsoft_azure"
                    v-model="selectedEmpresa.use_auth_microsoft_azure"
                    :options="options_use_auth_microsoft_azure"
                    buttons
                    :button-variant="
                        selectedEmpresa.use_auth_microsoft_azure
                        ? 'outline-primary'
                        : 'outline-secondary'
                    "
                    name="use_auth_microsoft_azure"
                  />
                </b-form-group>

              </b-col>

              <b-col v-show="selectedEmpresa.use_auth_microsoft_azure" sm="12" md="8" class="p-3 rounded">
                <b-row>

                  <!-- Id. de aplicación (cliente) -->
                  <b-col cols="12">
                    <b-form-group>
                      <label for="client_id"> Id. de aplicación (cliente) <span style="color: red">(*)</span> </label>
                      <b-form-input
                        id="client_id"
                        name="client_id"
                        v-validate="selectedEmpresa.use_auth_microsoft_azure ? 'required|max:255' : ''"
                        data-vv-as=" "
                        v-model="selectedEmpresa.client_id"
                        placeholder="00000000-0000-0000-0000-000000000000"
                      />
                      <span
                        class="text-danger span-error small"
                        v-text="errors.first('crearActualizarEmpresa.client_id')"
                      />

                      <p class="text-helpers">
                        <i class="fa fa-info-circle mr-1"></i>
                        <strong>Descripción</strong>: Este es el identificador único para tu aplicación registrada en Azure Active Directory.
                        <strong>Dónde obtenerlo</strong>: En el portal de Azure, navega a "Azure Active Directory" > "App registrations" > selecciona tu aplicación > copia el "Application (client) ID".
                      </p>

                    </b-form-group>
                  </b-col>

                  <!-- Id. de directorio (inquilino) -->
                  <b-col cols="12">
                    <b-form-group>
                      <label for="tenant_id"> Id. de directorio (inquilino) <span style="color: red">(*)</span> </label>
                      <b-form-input
                        id="tenant_id"
                        name="tenant_id"
                        v-validate="selectedEmpresa.use_auth_microsoft_azure ? 'required|max:255' : ''"
                        data-vv-as=" "
                        v-model="selectedEmpresa.tenant_id"
                        placeholder="00000000-0000-0000-0000-000000000000"
                      />
                      <span
                        class="text-danger span-error small"
                        v-text="errors.first('crearActualizarEmpresa.tenant_id')"
                      />

                      <p class="text-helpers">
                        <i class="fa fa-info-circle mr-1"></i>
                        <strong>Descripción</strong>: Este es el identificador del inquilino de Azure Active Directory al que pertenece tu aplicación.
                        <strong>Dónde obtenerlo</strong>: En el portal de Azure, navega a "Azure Active Directory" > "Properties" > copia el "Directory (tenant) ID".
                      </p>

                    </b-form-group>
                  </b-col>

                  <!-- Id. de directorio (inquilino) -->
                  <b-col cols="12">
                    <b-form-group>
                      <label for="secret_value"> Contraseña de la Aplicación (Secreto del cliente) <span style="color: red">(*)</span> </label>
                      <b-form-input
                        id="secret_value"
                        name="secret_value"
                        v-validate="selectedEmpresa.use_auth_microsoft_azure ? 'required|max:255' : ''"
                        data-vv-as=" "
                        v-model="selectedEmpresa.secret_value"
                        placeholder="00000~00000000-0000000000000000_00000000"
                      />
                      <span
                        class="text-danger span-error small"
                        v-text="errors.first('crearActualizarEmpresa.secret_value')"
                      />

                      <p class="text-helpers">
                        <i class="fa fa-info-circle mr-1"></i>
                        <strong>Descripción</strong>: Se trata de una cadena de secreto que la aplicación usa para probar su identidad al solicitar un token. También se conoce como contraseña de aplicación.
                        <strong>Dónde obtenerlo</strong>: En la sección de tu aplicación > selecciona "Certificates & secrets" > Haz clic en "New client secret" > Proporciona una descripción y selecciona una duración para el secreto.
                        > Haz clic en "Add". <i>Una vez que el secreto se haya creado, verás el valor del secreto en la lista. Este es el valor que necesitas usar.</i>
                      </p>

                    </b-form-group>
                  </b-col>

                </b-row>
              </b-col>

            </b-row>
          </b-collapse>
        </b-card>
      </div>

      <b-row v-if="validarPermisoComponente('empresa-editar-generales')" class="text-center mt-3">
        <b-col>
          <b-button type="submit" variant="primary" class=" float-right">
            <i class="fa fa-floppy-o fa-lg" />
            Guardar
          </b-button>
        </b-col>
      </b-row>
    </form>
  </div>
</template>

<script>
import { mapActions, mapMutations, mapState } from "vuex";
import Conexion from "./Conexion";
import { validarPermisoComponente } from "@/plugins/acl";

export default {
  name: "generales",
  components: {
    Conexion,
  },
  data() {
    return {
      opciones: [
        { text: "Si", value: 1 },
        { text: "No", value: 0 },
      ],
      options_use_auth_microsoft_azure: [
        { text: "Si", value: 1 },
        { text: "No", value: 0 },
      ],
      isOpenConfigAzure: false,
      validarPermisoComponente: validarPermisoComponente,
    };
  },
  watch: {
    async '$route.params.id'(newId, oldId) {
        if (newId !== oldId) {
            await this.loadData(newId);
        }
    }
  },
  computed: {
    ...mapState("empresa", ["selectedEmpresa", "accion", "listadoUsuarioInternos", "validateCompany"]),
  },
  async mounted() {
    await this.loadData(this.$route.params.id);
  },
  methods: {
    ...mapActions("empresa", [
      "guardaEmpresa",
      "actualizarEmpresa",
      "showValidateCompany",
      "getConexion",
      "getUsuariosInternos",
      'getConfigAzureByCompanyId'
    ]),
    ...mapMutations("empresa", [
      "setAccion",
      "resetSelectedEmpresa",
      "establecerNombreEmpresa",
      "setNitCompany",
      "validateCompanyUrl",
    ]),
    async loadData(companyId) {
        await this.showValidateCompany(companyId);
        await this.getConexion(companyId);

        if ('id' in this.selectedEmpresa && this.accion !== 'create') {
            this.validateCompanyUrl(companyId);

            if (!this.validateCompany && this.$route.path !== "/inicio") {
                this.$router.push("/inicio");
            }

            await this.getConfigAzureByCompanyId(this.selectedEmpresa);
        }

        await this.getUsuariosInternos();
    },
    toggleDropdownConfigAzure() {
      this.isOpenConfigAzure = !this.isOpenConfigAzure;
    },
    sanitizarNombre() {
      const nombre = this.selectedEmpresa.nombre.replace(
        /[\[\]/\\#,+()$~%'":*=?¿¡<>´{}]/g,
        ""
      );
      this.establecerNombreEmpresa(nombre);
    },
    sanitizarNit($event) {
      let keyCode = $event.keyCode ? $event.keyCode : $event.which;
      if (
        keyCode < 48 ||
        keyCode > 57 ||
        (this.selectedEmpresa.nit.length == 9 && $event.type != "paste")
      ) {
        if (keyCode != 8 || keyCode != 221) {
          $event.preventDefault();
        }
      }
      if ($event.type == "paste") {
        const number = $event.clipboardData.getData("text");
        const reg = new RegExp("^[0-9]+$");
        if (!reg.test(number)) {
          $event.preventDefault();
        }
      }
    },
    async guardarEmpresa() {
      await this.$validator
        .validateAll("crearActualizarEmpresa")
        .then(async (validado) => {
          if (validado) {
            if (this.accion === "update") {
              await this.actualizarEmpresa(this.$route.params.id);
            } else {
              await this.guardaEmpresa().then(async () => {
                await this.showValidateCompany(this.selectedEmpresa.id);
                await this.getConexion(this.selectedEmpresa.id);
                await this.getUsuariosInternos();
                await this.getConfigAzureByCompanyId(this.selectedEmpresa);
                await this.$router.push(`/empresas/${this.selectedEmpresa.id}`);
                this.setAccion("update");
              });
            }
          }
        });
    },
  },
};
</script>

<style scoped>

.bg-disabled{

  filter: blur(1px);
}

.text-helpers{
  font-size: 10pt;
  margin-top: 10pt;
  color: gray;
}

</style>
